var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7665_48714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9866 12.2261C23.9866 11.2429 23.9049 10.5253 23.7282 9.78125H12.2383V14.2192H18.9826C18.8467 15.3221 18.1124 16.9831 16.4807 18.0992L16.4578 18.2478L20.0907 20.998L20.3424 21.0225C22.654 18.9363 23.9866 15.8669 23.9866 12.2261Z",
    fill: "#0D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2372 23.9217C15.5413 23.9217 18.3152 22.8587 20.3413 21.025L16.4796 18.1017C15.4462 18.806 14.0592 19.2976 12.2372 19.2976C9.00096 19.2976 6.25427 17.2115 5.27515 14.3281L5.13164 14.34L1.35409 17.1969L1.30469 17.3311C3.31711 21.2376 7.45077 23.9217 12.2372 23.9217Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2758 14.3228C5.01745 13.5787 4.86794 12.7814 4.86794 11.9576C4.86794 11.1338 5.01745 10.3365 5.26221 9.59244L5.25536 9.43397L1.43048 6.53125L1.30533 6.58942C0.47592 8.21052 0 10.0309 0 11.9576C0 13.8843 0.47592 15.7047 1.30533 17.3258L5.2758 14.3228Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2372 4.62403C14.5351 4.62403 16.0852 5.59402 16.9691 6.40461L20.4228 3.10928C18.3017 1.1826 15.5413 0 12.2372 0C7.45077 0 3.3171 2.68406 1.30469 6.59056L5.26156 9.59359C6.25427 6.7102 9.00096 4.62403 12.2372 4.62403Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7665_48714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1f39e9689d5e93753b9ec27d6f6920a8.svg";
export { ForwardRef as ReactComponent };